import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ClientLayout from './components/ClientLayout';
import UserLayout from './components/UserLayout';
import AdminLayout from './components/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClientList from './pages/ClientList';
import Levels from './pages/Levels';
import UserBonuses from './pages/UserBonuses';
import PrivateRoute from './components/PrivateRoute';
import Prompts from './pages/Prompts';
import GenerationEvents from './pages/GenerationEvents';
import Attachments from './pages/Attachments';
import PlanetPrompts from './pages/PlanetPrompts';
import UserAdminPanel from './pages/UserAdminPanel';
import AdminDashboard from './pages/AdminDashboard';
import AdminClients from './pages/AdminClients';
import AdminSettings from './pages/AdminSettings';
import BonusUseRequests from './pages/BonusUseRequests';
import MyBalance from './pages/MyBalance';
import ClientSettings from './pages/ClientSettings';

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/client" replace />} />
            <Route path="/client" element={<PrivateRoute><ClientLayout /></PrivateRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<ClientList />} />
              <Route path="levels" element={<Levels />} />
              <Route path="bonuses" element={<UserBonuses />} />
              <Route path="bonus-requests" element={<BonusUseRequests />} />
              <Route path="prompts" element={<Prompts />} />
              <Route path="generation-events" element={<GenerationEvents />} />
              <Route path="attachments" element={<Attachments />} />
              <Route path="planet-prompts" element={<PlanetPrompts />} />
              <Route path="my-balance" element={<MyBalance />} />
              <Route path="client-settings" element={<ClientSettings />} />
            </Route>
            <Route path="/user" element={<PrivateRoute><UserLayout /></PrivateRoute>}>
              <Route index element={<UserAdminPanel />} />
            </Route>
            <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 